import React, { Component } from 'react';
import SecureLayout from '../../../templates/secure';
import {NavLink} from 'react-router-dom';
import _ from 'lodash';

class GoalsAdd extends Component{
	render(){
		const {project, match} =this.props;
		const { modality, state, municipality } = match.params;
		let gc = _.find(project.permissions, (o) => {return o==='Create'});
		return (
			gc ?
				<p>
					<NavLink to={`/proyecto/${modality}/proigualdad-meta/crear/${state}${municipality ? `/${municipality}`:''}`} className="button is-small is-inm-purple">{'Agregar Meta'}</NavLink>
				</p>:''
		)
	}
}

export default SecureLayout(GoalsAdd);


// WEBPACK FOOTER //
// ./src/elements/project/widgets/goals_add.jsx